module.exports = __webpack_public_path__ + "media/images/home/sprite-965308048764bba6e73be47e67b42010.svg";